import { createApiInstanse } from '../../context/api/createApiInstanse';
const instance = createApiInstanse();
export default instance;